import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

import { Publicacion } from '../models/publicacion';
import { PublicacionService } from '../services/publicacion.service';
import { DatePipe } from '@angular/common'


@Component({
  selector: 'app-noticia',
  templateUrl: './noticia.component.html',
  styleUrls: ['./noticia.component.css']
})
export class NoticiaComponent implements OnInit {

  model: Publicacion = new Publicacion();
  url = environment.imgUrl;

  constructor(private modelService: PublicacionService, private route: ActivatedRoute, public datepipe: DatePipe) {
    this.model.id = Number(this.route.snapshot.paramMap.get('id'));
  }

  ngOnInit() {
    this.modelService.get(this.model.id).subscribe(val => {
      this.model = val;

      this.model.fecha = this.datepipe.transform(this.model.fecha, 'dd-MM-yyyy')

    });
  }

}
